// extracted by mini-css-extract-plugin
export default {"smallCard":"regionInfo_smallCard__SJJLz","value":"regionInfo_value__Jo-Zm"};